'use strict';

angular.module('ClinicApp').controller('ModalDoctorsWithInsurance', function($scope, $modalInstance, doctors, OCPhotoUtil) {
  $scope.doctors = doctors;

  $scope.getPhotoSource = function(doctor) {
    return OCPhotoUtil.primaryPhotoForModel('doctor', doctor.primaryPhoto);
  };

  $scope.select = function(doctor) {
    $modalInstance.close(doctor);
  };

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };
});
